import {useEffect, useState} from "react"

export const MOBILE_BREAKPOINT = 1024;

export function useIsMobile() {
    const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined)

    useEffect(() => {
        const checkIsMobile = () => {
            // Check if the PRIMARY input is touch (coarse pointer = touch-first device like tablet/phone)
            // This excludes touchscreen laptops which have a mouse/trackpad as primary input
            const isTouchPrimary = window.matchMedia('(pointer: coarse)').matches

            // Consider it mobile if:
            // 1. Screen width is below breakpoint, OR
            // 2. Primary input is touch (tablets/iPads but NOT touchscreen laptops)
            const isNarrow = window.innerWidth < MOBILE_BREAKPOINT
            return isNarrow || isTouchPrimary
        }

        const widthQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
        const pointerQuery = window.matchMedia('(pointer: coarse)')

        const onChange = () => {
            setIsMobile(checkIsMobile())
        }

        widthQuery.addEventListener("change", onChange)
        pointerQuery.addEventListener("change", onChange)
        setIsMobile(checkIsMobile())

        return () => {
            widthQuery.removeEventListener("change", onChange)
            pointerQuery.removeEventListener("change", onChange)
        }
    }, [])

    return !!isMobile
}

export const TABLET_BREAKPOINT = 768;

export function useIsTablet() {
    const isMobile = useIsMobile();
    const largerWidth = window.innerWidth >= TABLET_BREAKPOINT;
    return isMobile && largerWidth;
}
